import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';
import { BrowserTracing } from '@sentry/tracing';

import App from './App';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './ErrorBoundary';
import helpers from './helpers';
import loadFontsConditionally from './utils/fontLoader';

// Only initialize Sentry for real users
if (!helpers.isBotOrPrerender()) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}

// Load fonts conditionally based on bot detection
loadFontsConditionally();

ReactDOM.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
  document.getElementById('root')
);

// Only measure web vitals for real users
if (!helpers.isBotOrPrerender()) {
  reportWebVitals();
}
